'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./cart/cart'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/notifyme'));
});
